import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    StyleSheet,
    Modal,
    StatusBar,
    Platform
} from 'react-native';

import {
    JDTouchable,
    JDNativeSystem,
    JDImage,
    JDText
} from '@jdreact/jdreact-core-lib'
import { px, pt } from '../common/utils';

class More extends PureComponent {
    constructor(props) {
        super(props);
    };

    render() {
        return (
            <JDTouchable onPress={this.props.showMore}>
                <View style={[st.container, this.props.style]}>
                    {[1, 2, 3].map((x, i) => (
                        <View style={[st.more_point]} key={i} />
                    ))}
                </View >
            </JDTouchable>
        )
    }
}

const st = StyleSheet.create({
    container: {
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        width: pt(44),
        height: pt(44),
    },
    more_point: {
        width: pt(4),
        height: pt(4),
        borderRadius: pt(2),
        marginHorizontal: pt(1.5),
        backgroundColor: '#333'
    }
});

More.contextTypes = {
    router: PropTypes.object
};

export default More;